import React, { useEffect, useMemo, useState } from "react";
import moment from "moment";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import TemplateCover from "../template-cover";


/** ======== Component ======== */
import Button from "components/button/button";
// import TemplateOne from "./template-one";
// import TemplateTwo from "./template-two";
// import TemplateThree from "./template-three";
// import TemplateFour from "./template-four";
import { TEMPLATE_NAME_1, TEMPLATE_NAME_2, TEMPLATE_NAME_3,TEMPLATE_NAME_4 } from "constants/options";
import {templatesPlaceholder} from "utils/constant";
import TemplateOneThemeOnePageOneNP from "assets/images/Color1/color-1-telplate-1-P1.png"
import { LONG_SIZE } from "../resume";

export default function ResumeItem({
  link_id,
  template_name,
  template_color = {},
  personal_info = {},
  social_media = {},
  more_info = {},
  updated_at,
  resume_milestones = {},
  onDownload = () => {},
  onEdit = () => {},
  onPreview = () => {},
  profile_image_withURL,
  image_template,
  show_milestone_image,
  onRemove = () =>{},
  profile
}) {
  const [milestones, setMilestones] = useState({});
  const {t} = useTranslation();
  const [primaryColor, secondaryColor, tertiaryColor, quarternary] =
    useMemo(() => {
      if (template_color) {
        return template_color?.value ||  ["", "", "", ""];
      }
      return ["", "", "", ""];
    }, [template_color]);

  useEffect(() => {
    /** set featured milestone */
    if (resume_milestones.featured && !_.isEmpty(resume_milestones.featured)) {
      let featured = [];
      resume_milestones.featured.forEach((f) => {
        if(f.milestone){
          featured.push(f.milestone);
        }
      });
      setMilestones((prev) => ({
        ...prev,
        featured,
      }));
    }
    /** set current milestone */
    if (resume_milestones.current && !_.isEmpty(resume_milestones.current)) {
      let current = [];
      resume_milestones.current.forEach((c) => {
        if(c.milestone){
        current.push(c.milestone);
        }
      });
      setMilestones((prev) => ({
        ...prev,
        current,
      }));
    }
    /** set past milestone */
    if (resume_milestones.past && !_.isEmpty(resume_milestones.past)) {
      let past = [];
      resume_milestones.past.forEach((p) => {
        if(p.milestone){
          past.push(p.milestone);
        }
      });
      setMilestones((prev) => ({
        ...prev,
        past,
      }));
    }
  }, [resume_milestones]);

 
  const defaultUrl = ()=>{
    let templateMod = templatesPlaceholder; 
      let obj = _.find(templateMod, { key: template_color?.key });
      if (!_.isEmpty(obj)) {
        const imageDefault =  _.find(obj.templates, { name: template_name });
        if(!_.isEmpty(imageDefault)){ 
          return imageDefault.images[0].image;
        }
      }
      return null;
  }

  return (
    <div className="w-full border border-primary rounded-md overflow-hidden">
      <div className={`w-full relative cursor-pointer template-hover overflow-hidden`}>
        <div className="w-full h-full bg-white bg-opacity-40 absolute z-9999 top-0 rounded-t-md hidden-template-hover">
          <div className="w-full h-full grid justify-center items-center px-9.5">
            {/* actions */}
            <div className="w-full flex flex-col space-y-3">
              <Button
                buttonName={t("previewResume")}
                buttonTextClass="text-xs font-semibold text-pr"
                buttonRadius="6px"
                buttonClass="bg-transparent border-2 border-primary px-8 py-4.6"
                onClick={onPreview}
              />
              <Button
                buttonName={t("editResume")}
                buttonTextClass="text-xs font-semibold text-white"
                buttonRadius="6px"
                buttonClass="bg-primary w-full px-8 py-4.6"
                onClick={onEdit}
              />
              <Button
                buttonName={t("shareDownload")}
                buttonTextClass="text-xs font-semibold text-white"
                buttonRadius="6px"
                buttonClass="bg-lightBlack px-8 py-4.6"
                onClick={onDownload}
              />
              <Button
                buttonName={"Delete Resume"}
                buttonTextClass="text-xs font-semibold text-red"
                buttonRadius="6px"
                buttonClass="bg-transparent border-2 border-red px-8 py-4.6"
                onClick={onRemove}
              />
            </div>
            {/* end actions */}
          </div>
        </div>
       
        {/* <div 
        className="w-full h-[300px] bg-gray-100"
        style={{transformOrigin: "top left", transform: "scale(0.38)"}}
        >
          <img
            src={image_template || defaultUrl() || TemplateOneThemeOnePageOneNP}
            className="max-h-full max-w-full object-contain rounded-t-md"
            alt="resume-template-one"
          />
          <TemplateCover
            {...{
              personal_info,
              social_media,
              profile,
              more_info,
              template_name,
              template_color,
            }}
          />
        </div> */}

        <div className="w-full h-[300px] bg-[#ffffff] relative overflow-hidden">
          <div
            className="absolute top-0 left-1/2"
            style={{
              transform: "translateX(-50%) scale(0.33)",
              transformOrigin: "top center",
            }}
          >
            <TemplateCover
              {...{
                personal_info,
                social_media,
                profile,
                more_info,
                template_name,
                template_color,
              }}
            />
          </div>
        </div>


      </div>
      <div className="w-full py-4 px-3 border-t border-resumeBorder template-hover-footer">
        <p className="text-lightBlack text-base font-medium">{
          template_name === TEMPLATE_NAME_1 ? t('templateName1') :
          template_name === TEMPLATE_NAME_2 ? t('templateName2') :
          template_name === TEMPLATE_NAME_3 ? t('templateName3') :
          t('templateName4') 
          }</p>
        <p className="text-darkerGray text-sm leading-6">
          {t('editedLast')} {moment(updated_at).format("DD MMMM YYYY hh:ss A")}
        </p>
      </div>
    </div>
  );
}
